import React, { useContext, useEffect, useState } from "react";
import { View, Text, StatusBar, ScrollView } from "react-native";
import { Avatar } from "react-native-elements";
import { useNavigation } from "@react-navigation/native";
import { Feather as Icons, FontAwesome5, MaterialCommunityIcons } from "@expo/vector-icons";
import { createBottomTabNavigator } from "@react-navigation/bottom-tabs";

import Route from "../Route";
import Drivers from "../Drivers";
import Clients from "../Clients";
import Profile from "../../Profile";

import { Header, CardDelivery, Container, Content, TabBar } from "../../../components";
import {
  HeaderInfos,
  TextWelcome,
  NameUser,
  IconFE,
  TitleMain,
  Deliveries,
  OrderingOptions,
  TextPending,
  TextHandedOut,
  ButtonTextHandedOut,
  ButtonTextPending,
} from "./styles";
import RouteContext from "../../../context/route";

function ReportAdmin() {
  const navigation = useNavigation();
  const { getIndividualOrder, pendingOrders, completeOrders, setFinalizeDelivery } = useContext(RouteContext);
  const [deliveryType, setDeliveryType] = useState(0);
  
  function handlePending() {
    setDeliveryType(0);
  }

  function handleHandedOut() {
    setDeliveryType(1);
  }

  async function handleDetailsDelivery(id: number) {
    try {
      await getIndividualOrder(id);
      setFinalizeDelivery({order_status: '1', problem: '', image: ''});
      navigation.navigate('DetailsDeliveryAdmin');
    } catch (_) {
      console.log('error getIndividualOrder screen');
    }
  }

  return (
    <Container>
      <Header />
      <Content>
        <TitleMain>
          <Deliveries>Entregas</Deliveries>

          <OrderingOptions>
            <ButtonTextPending onPress={handlePending}>
                <TextPending deliveryType={deliveryType}>Pendentes</TextPending>
            </ButtonTextPending>
            <ButtonTextHandedOut onPress={handleHandedOut}>
                <TextHandedOut deliveryType={deliveryType}>Entregues</TextHandedOut>
            </ButtonTextHandedOut>
          </OrderingOptions>
        </TitleMain>

        <ScrollView showsVerticalScrollIndicator={false}>
            {deliveryType === 0 ? (
                <>
                  {pendingOrders.map((item: any, index: number) => {
                    const date = new Date(item.date_order);
                    return (
                      <CardDelivery
                        key={index}
                        name={item.destiny_name}
                        date={date.toLocaleDateString()}
                        status={item.order_status}
                        city={`${item.destiny_city} - ${item.destiny_state}`}
                        onPress={() => handleDetailsDelivery(item.id)}
                      />
                    )
                  })}
                </>
            ) : (
                <>
                  {completeOrders.map((item: any, index: number) => {
                    const date = new Date(item.date_order);
                    return (
                      <CardDelivery
                        key={index}
                        name={item.destiny_name}
                        date={date.toLocaleDateString()}
                        status={item.order_status}
                        city={`${item.destiny_city} - ${item.destiny_state}`}
                        onPress={() => handleDetailsDelivery(item.id)}
                      />
                    )
                  })}
                </>
            )}
        </ScrollView>
      </Content>
    </Container>
  );
}

const Tab = createBottomTabNavigator();

export default function App() {
  return (
    <Tab.Navigator
      screenOptions={{ headerShown: false }}
      tabBar={(props) => <TabBar {...props} />}
    >
      <Tab.Screen
        name="Entregas"
        component={ReportAdmin}
        options={{
          tabBarIcon: ({ focused }) => {
            return (
              <Icons
                name="menu"
                size={25}
                color={focused ? "#3F50B5" : "gray"}
              />
            );
          },
        }}
      />
      <Tab.Screen
        name="Rotas"
        component={Route}
        options={{
          tabBarIcon: ({ focused }) => {
            return (
              <MaterialCommunityIcons
                name="map-marker-path"
                size={25}
                color={focused ? "#3F50B5" : "gray"}
              />
            );
          },
        }}
      />
      <Tab.Screen
        name="Motoristas"
        component={Drivers}
        options={{
          tabBarIcon: ({ focused }) => {
            return (
              <FontAwesome5
                name="truck"
                size={25}
                color={focused ? "#3F50B5" : "gray"}
              />
            );
          },
        }}
      />
      <Tab.Screen
        name="Clientes"
        component={Clients}
        options={{
          tabBarIcon: ({ focused }) => {
            return (
              <Icons
                name="users"
                size={25}
                color={focused ? "#3F50B5" : "gray"}
              />
            );
          },
        }}
      />
      <Tab.Screen
        name="Perfil"
        component={Profile}
        options={{
          tabBarIcon: ({ focused }) => {
            return (
              <FontAwesome5
                name="user-circle"
                size={25}
                color={focused ? "#3F50B5" : "gray"}
              />
            );
          },
        }}
      />
    </Tab.Navigator>
  );
}
